import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import persist from '@alpinejs/persist'
import focus from '@alpinejs/focus'
import 'focus-visible'

// Global get CSRF token function (used by forms).
window.getToken = async () => {
    return await fetch('/!/DynamicToken/refresh')
        .then((res) => res.json())
        .then((data) => {
            return data.csrf_token
        })
        .catch(function (error) {
            this.error = 'Something went wrong. Please try again later.'
        })
}

// Call Alpine.
window.Alpine = Alpine
Alpine.plugin(collapse)
Alpine.plugin(persist)
Alpine.plugin(focus)
Alpine.start()

import Vue from 'vue';
import VueSelect from 'vue-select';
import 'vue-select/dist/vue-select.css'
import store from './store'; // Add this line
import Twitch from './components/Twitch.vue';
import Charity from './components/Charity.vue';
import ChannelCards from './components/ChannelCards.vue';
import Apply from './components/Apply.vue';
import Account from './components/Account.vue';
import Heatmap from './components/Heatmap.vue';
import Donobar from './components/Donobar.vue';
import RaidTrain from './components/RaidTrain.vue';
window.$ = window.jQuery = require('jquery');

Vue.component('twitch', Twitch);
Vue.component('channel-cards', ChannelCards);
Vue.component('apply', Apply);
Vue.component('account', Account);
Vue.component('charity', Charity);
Vue.component('heatmap', Heatmap);
Vue.component('donobar', Donobar);
Vue.component('raidtrain', RaidTrain);
Vue.component('v-select', VueSelect);


if (document.getElementById('twitch-wrapper')) {
    const twitchWrapper = document.getElementById('twitch-wrapper');
    const channelToHighlight = twitchWrapper.getAttribute('data-channel-to-highlight');
    const taglineImage = twitchWrapper.getAttribute('data-tagline-image');
    const underBannerText = twitchWrapper.getAttribute('data-under-banner-text');
    const underBannerTextColor = twitchWrapper.getAttribute('data-under-banner-text-color');
    const minViewerCount = twitchWrapper.getAttribute('data-min-viewer-count');

    new Vue({
        store,
        render: h => h(Twitch, {
            props: {
                channelToHighlight,
                taglineImage,
                underBannerText,
                underBannerTextColor,
                minViewerCount,
            },
        }),
    }).$mount('#twitch-wrapper');
}


if (document.getElementById('charity')) {
    new Vue({
        store,
        render: h => h(Charity),
    }).$mount('#charity');
}

if (document.getElementById('apply')) {
    new Vue({
        render: h => h(Apply),
    }).$mount('#apply');
}

if (document.getElementById('account')) {
    new Vue({
        render: h => h(Account),
    }).$mount('#account');
}

if (document.getElementById('heatmap')) {
    new Vue({
        render: h => h(Heatmap),
    }).$mount('#heatmap');
}

if (document.getElementById('donobar')) {
    new Vue({
        render: h => h(Donobar),
    }).$mount('#donobar');
}

if (document.getElementById('raidtrain')) {
    new Vue({
        render: h => h(RaidTrain),
    }).$mount('#raidtrain');
}

if (document.getElementById('channel-cards')) {
    const channelCards = document.getElementById('channel-cards');
    const tabHighlightColor = channelCards.getAttribute('data-tab-highlight-color');
    const tabHighlightTextColor = channelCards.getAttribute('data-tab-highlight-text-color');

    new Vue({
        store,
        render: h => h(ChannelCards, {
            props: {
                tabHighlightColor,
                tabHighlightTextColor,
            },
        }),
    }).$mount('#channel-cards');
}
